/** @module Operations/AggregateSubsectionsWidget */
define([
	"dojo/_base/declare",
	"dijit/registry",
	"csi/_base/underscore",
	"csi/table/Widget"
], function(declare,registry,_,Widget) {

	return declare(Widget, {
		bHierarchicalSelection: true,

		/**
		 * Allow aggregation at any level of view
		 * @param {Object} params - parameters for query level
		 * @param {boolean} bRoot - true if root query level
		 * @return {QueryLevel}
		 */
		_createQueryLevel: function(params, bRoot) {
			var	ql = this.inherited(arguments);
			if (ql.bResults && !ql.groupSpec) {
				ql.bCanAggregate = true;
			}

			return ql;
		},

		/**
		 * if parent item is selected, then select all items - there is code to do this in ViewSelect controller, but that may fail if nodes are not yet in cache
		 * @param {QueryResult} qrParent - parent query result of result rows
		 * @param {DOMNode} row - parent row where to insert results
		 * @param {DOMNode} rowNext - row before which to insert results
		 * @param {QueryResults} results - set of result nodes to insert into view
		 * @param {boolean} bRefresh - true if view is being refreshed rather than being build first time
		 * @return {Deferred}
		 */
		_buildViewResults: function(/*QueryResult*/qrParent, /*DOMNode*/row, /*DOMNode*/rowNext, /*QueryResults*/results, /*Boolean*/bRefresh) {
			var	node = this.getRowNode(row);
			if (node.Questions) {
				var	ctx = this.getContext(node.$URL);
				var	fd = this.defView.m_formData;

				if (fd.isSelection(ctx) && !fd.isAggregated(ctx)) {
					ctx.forEach(results, function(ctx) {
						fd.changeSelection(ctx, true);
					});
				}
			}

			return this.inherited(arguments);
		}
	});
});